import { Fragment as AndroidNotificationSetting } from 'react';

export default AndroidNotificationSetting;